<template>
	<div>
		<div style="position: relative;width: 80%;margin: 0 auto;">
			<router-view></router-view>
		</div>
		
	</div>
</template>

<script>
	export default {
		name: 'App',
		data(){
			return {
				
			}
		},
		methods:{
			
			
		},
		mounted() {
		  // 获取 DOM 元素
			
		}
	}
</script>

<style>
	*{
		margin: 0;
		padding: 0;
		-webkit-tap-highlight-color:rgba(255,255,255,0);
		-webkit-tap-highlight-color: transparent;
		-webkit-font-smoothing: antialiased;
		    font-family: Microsoft yahei;
		outline:none;
	}
	body {
	    -webkit-text-size-adjust: 100%!important;
	}
	
	
</style>
